
import React, { Component } from "react";
import { Modal, Form, Col, Button, Row } from "react-bootstrap";
import { graphql } from "react-apollo"
import { gql } from "apollo-boost";
import * as Cookies from "es-cookie"
import './_buttonpopup.scss';
import '../_lecturerModal.scss';
import SelectDropdown from '../SelectDropdown';
import { canEdit } from "../../../../utils/modulePermissions";

// /lecturer-timeTable → "Lecturer_timetable". This modal is only reachable through the
// gated "Period Creation" opener in LecturerTimeTableHome, which already raises the
// Access Denied modal. This is a silent backstop so the save can't fire even if the
// modal is opened some other way — no second modal of its own.
const LECTURER_TIMETABLE_MODULE = ["Lecturer_timetable"];

const ADD_CLASS_PERIODS = gql`
  mutation($params: AddClassPeriods) {
    addClassPeriods(params: $params)
  }
`;

class PeriodCreationModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      branch_id: '',
      branchError: '',
      exam_id: '',
      examError: '',
      count: 0,
      update: [],
      dataClear: 1,
      periodError: "",
      loadingSpinner: 0,
      submitted: false,
      getExams: [],
      defaultvalue: 0,
      currentStep: 1,
      submitError: ""
    };
  }


  addRow = () => {
    let countValue = parseInt(this.state.count)
    this.setState({
      count: countValue + 1
    })

    let event = {
      target: {
        name: "period_name",
        value: ""
      }
    }
    this.handleChange(event, countValue + 1)
  }
  handleChange = (e, i) => {
    let name = e.target.name;
    let value = e.target.value;


    this.setState(preState => {

      let array = preState.update;

      let array1 = [];

      if (array.length > 0) {
        if (array[i] != undefined) {
          array.map((item2, index) => {
            if (i == index) {
              let period_name = item2.period_name;
              let period_startTime = item2.period_startTime;
              let period_endTime = item2.period_endTime;
              if (name == "period_name") {
                period_name = value

              } else if (name == "period_startTime") {
                period_startTime = value;
              } else {
                period_endTime = value
              }
              array1.push({ period_name: period_name, period_startTime: period_startTime, period_endTime: period_endTime, period_name_error: "", period_startTime_error: "", period_endTime_error: "" })
            } else {
              array1.push({ ...item2 })
            }
          })
        } else {
          array1.push(...array, { period_name: "", period_startTime: "", period_endTime: "", period_name_error: "", period_startTime_error: "", period_endTime_error: "" })
        }

      } else {
        array1.push({ period_name: "", period_startTime: "", period_endTime: "", period_name_error: "", period_startTime_error: "", period_endTime_error: "" })
      }
      return {
        update: array1
      }

    })
  }

  handleSubmit = () => {
    // Silent is_edit backstop — the opener already gated entry with its own modal.
    if (!canEdit(LECTURER_TIMETABLE_MODULE)) return;

    if (this.state.branch_id == "") {
      this.setState({ branchError: "Please Select Branch" })
      return ""
    }

    let stopExecuting = false;
    this.state.update.some((obj, i) => {

      let errorUpdate = this.state.update

      if (obj.period_name == "" || obj.period_name == undefined) {
        errorUpdate[i] = { ...obj, period_name_error: "Type period name" }
        this.setState({ update: errorUpdate })
        stopExecuting = true
        return true;
      }
      if (obj.period_startTime == "" || obj.period_startTime == undefined) {
        errorUpdate[i] = { ...obj, period_starttime_error: "Select start time" }
        this.setState({ update: errorUpdate })
        stopExecuting = true
        return true
      }
      if (obj.period_endTime == "" || obj.period_endTime == undefined) {
        errorUpdate[i] = { ...obj, period_endtime_error: "Select end time" }
        this.setState({ update: errorUpdate })
        stopExecuting = true
        return true
      }
    })

    if (stopExecuting) {
      return ""
    }

    let array = []
    if (this.state.update.length > 0) {
      this.state.update.map((item) => {
        let period_time = `${item.period_startTime} - ${item.period_endTime}`
        array.push({ period_name: item.period_name, period_time: period_time })
      })
    }
    this.setState({ loadingSpinner: 1, submitError: "" });

    this.props.addClassPeriods({
      variables: {
        params: {
          branch_id: parseInt(this.state.branch_id),
          institute_id: parseInt(Cookies.get("institutionid")),
          period_details: array,
        },
      },
    })
      .then(() => {
        this.setState({ loadingSpinner: 0, currentStep: 5 });
        setTimeout(() => { this.SetpageLoad(); }, 1000);
      })
      .catch((error) => {
        const msg = error && error.graphQLErrors ? error.graphQLErrors.map((x) => x.message) : String(error);
        this.setState({ submitError: msg, loadingSpinner: 0 });
        console.error("ERR =>", msg);
      });
  }

  SetpageLoad = () => {
    this.setState({ currentStep: 1, submitError: "" });
    this.props.onHide();
  };

  deleteHandle = (i) => {

    let updatedrows = this.state.update.filter((item, index) => index != i)
    console.log("hhh", updatedrows, i);
    this.setState({
      update: updatedrows, count: this.state.count - 1
    })
  }
  componentDidUpdate() {
    if (this.props.show === true && this.state.dataClear == 0) {
      this.setState({
        dataClear: 1,
        branch_id: '',
        exam_id: '',
        examError: '',
        branchError: '',
        count: 0,
        loadingSpinner: 0,
        update: [],
        submitted: false
      })
    }
    if (this.props.show === false && this.state.dataClear == 1) {
      this.setState({ dataClear: 0 })
    }
  }


  handleInputChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    // Branch is the only filter now — selecting one starts the first period row.
    // (Exam is no longer chosen here; periods are saved for every exam of the branch.)
    if (name == "branch") {
      if (value != "0") {
        this.setState({
          branch_id: value,
          branchError: '',
          exam_id: '',
          examError: '',
          count: 0,
          update: [],
          periodError: ""
        });
        this.handleChange({ target: { name: "period_name", value: "" } }, 0);
      } else {
        this.setState({
          branch_id: '',
          branchError: '',
          exam_id: '',
          examError: '',
          count: 0,
          update: [],
          periodError: ""
        });
      }
    }
  };

  render() {
    console.log("arrr", this.state)
    return (
      <Modal
        {...this.props}
        size="lg"
        dialogClassName="ltt-modal"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title><i className="fas fa-clock" /> Period Creation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col xl={12} lg={12} md={12} sm={12}>
              <Form>
                <Form.Row>
                  <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectBranch">
                    <Form.Label className="ltt-field-label">Branch</Form.Label>
                    <SelectDropdown
                      options={this.props.globals.globalBranches.map(b => ({ value: b.id, label: b.branch_name }))}
                      value={this.state.branch_id}
                      placeholder="Select Branch"
                      onSelect={(val) => this.handleInputChange({ target: { name: "branch", value: String(val) } })}
                    />
                    <Form.Text className="form-text text-danger" type="invalid">
                      {this.state.branchError}
                    </Form.Text>
                  </Form.Group>

                </Form.Row>
              </Form>
            </Col>
          </Row>

          {
            this.state.update.length > 0 ? (this.state.update.map((item, i) => (
              <>

                <div className="row mb-4 mt-3">

                  <div className="col-sm-3 mbottom">
                    <h6>Period Name</h6>
                    <input type="text" className="form-control" placeholder="Enter Period Name" onChange={(e) => this.handleChange(e, i)} value={item.period_name} name="period_name" />
                    <span className="text-danger">{item.period_name_error}</span>
                  </div>
                  <div className="col-sm-3 col-4 mbottom">
                    <h6>Period Start Time</h6>
                    <input type="time" onChange={(e) => this.handleChange(e, i)} value={item.period_startTime} name="period_startTime" />
                    <div>
                      <span className="text-danger">{item.period_starttime_error}</span>
                    </div>
                  </div>
                  <div className="col-sm-3 col-4 mbottom">
                    <h6>Period End Time</h6>
                    <input type="time" onChange={(e) => this.handleChange(e, i)} value={item.period_endTime} name="period_endTime" />
                    <div>
                      <span className="text-danger">{item.period_endtime_error}</span>
                    </div>
                  </div>
                  <div className="col-sm-3 col-4 mt-4">
                    {
                      this.state.update.length > 1 ? (
                        <button onClick={() => this.deleteHandle(i)} className="ltt-modal-delete"><i className="far fa-trash-alt" style={{fontSize:"15px"}} /></button>
                      ) : ("")
                    }
                  </div>
                </div>

              </>
            ))) : ("")
          }
          {
            this.state.update.length > 0 ? (
              <div>
                <button type="button" className="ltt-modal-add" onClick={this.addRow}>
                  <i className="fas fa-plus" /> Add Period
                </button>
              </div>
            ) : ("")
          }
        </Modal.Body>
        <Modal.Footer variant="white" >
          <Row>
            <Col sm={12}>
              {this.state.currentStep == 5 ? (
                <Form.Text className="form-text text-success mb-2 " style={{ textAlign: "center" }}>
                  Periods Create Successfully
                </Form.Text>
              ) : (
                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                  {this.state.submitError}
                </Form.Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col sm={12} style={{ display: "block", textAlign: "center" }}>
              <button className="ltt-modal-submit" onClick={(e) => this.handleSubmit()}>
                {
                  this.state.loadingSpinner == 1 ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : <i className="fas fa-check" />
                }
                Create Period</button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );

  }
}
export default graphql(ADD_CLASS_PERIODS, {
  name: "addClassPeriods"
})(PeriodCreationModal);


 